// Sets the auth token if provided in route query.
import { AUTH_TOKEN_NAME } from '@/config'

export default function authToken ({ to, next, nextMiddleware }) {
  if (to.query && to.query._token) {
    localStorage.setItem(AUTH_TOKEN_NAME, to.query._token)
    delete to.query._token

    return next(to)
  }

  return nextMiddleware()
}
